export const HIDE_FIELDS = new Set(['sfid', 'systemmodstamp', 'lastmodifiedbyid', 'lastmodifieddate', 'createddate', 'createdbyid']);

export const DESCRIPTION_TRUNCATE_LENGTH = 150;
